// Mutations
export const SET_EVENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.events.data = payload
    state.events.lastUpdate = new Date()
  }
}
export const ADD_EVENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.events.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.events.data.push(data)
      }
    })
  }
}
export const SET_EVENTS_LOADING = (state, payload) => {
  state.events.loading = payload
}

export const SET_PROSPECTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.prospects.data = payload
    state.prospects.lastUpdate = new Date()
  }
}
export const ADD_PROSPECTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.prospects.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.prospects.data.push(data)
      }
    })
  }
}
export const SET_PROSPECTS_LOADING = (state, payload) => {
  state.prospects.loading = payload
}

